import PropTypes from 'prop-types'
import React, { ReactNode } from 'react'
import { BaseRootStore } from 'src/store/BaseRootStore'
import { AppContext } from './AppContext'
import { RootStore } from './store/RootStore'

let store: BaseRootStore | undefined
const AppStoreProvider = ({
                            children,
                            injectedRootStore
                          }: { children: ReactNode, injectedRootStore?: BaseRootStore }) => {
  const rootStore = store ?? injectedRootStore ?? RootStore.getInstance()
  return <AppContext.Provider value={{ store: rootStore }}>{children}</AppContext.Provider>
}

AppStoreProvider.propTypes = {
  children: PropTypes.any,
}

export default AppStoreProvider

